import React, { useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { SendFileUploadFileReducer } from '../../Redux/Actions/FileUpload/FileUpload'
import notificationGlobal from '../Global/NotificationGlobal'
import { Card, Tag, Upload, DatePicker, Typography } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import Cargando from '../../Assets/Images/FileUpload/Cargando.gif'
import DescargaExitosa from '../../Assets/Images/FileUpload/Descarga exitosa.gif'
import PreCarga from '../../Assets/Images/FileUpload/Pre-carga.gif'
import Error from '../../Assets/Images/FileUpload/error.gif'
import '../../Styles/Components/FileUpload/CardFile.css'

const CardFile = ({ title, subtitle, url, disabled, area, template, mode, categoria }) => {

    const { Meta } = Card
    const { Text } = Typography

    const dispatch = useDispatch()

    const [sendDataFile, setSendDataFile] = useState(false)
    const [errorFile, setErrorFile] = useState(false)
    const [showDatePicker, setShowDatePicker] = useState(false)
    const [dateDatePicker, setDateDatePicker] = useState(null)
    const [datePickerKey, setDatePickerKey] = useState(0) // Nuevo estado para forzar re-render del DatePicker

    const [sendLoading, setLoading] = useState(false)

    const RefFile = useRef(null)

    const [uploadFile, setUploadFile] = useState({
        url: url,
        titleFile: title,
        dataFile: null,
        typeFile: null,
        nameFile: null,
        sending: false,
        categoria: categoria,
        subcategoryUrl: null  // Add this to store the selected subcategory URL
    })

    const props_upload = {
        onRemove: (file) => {
            setUploadFile({ ...uploadFile, dataFile: null, nameFile: null, typeFile: null, date: null })
        },
        beforeUpload: (file) => {
            setUploadFile({ ...uploadFile, dataFile: file, nameFile: file.name, typeFile: file.type, date: dateDatePicker })
            return false;
        },
    }
    const lastSelectedMonthRef = useRef(null);

    // Función para manejar la selección de mes
    const handleMonthSelect = (_, date) => {
        const dateString = date ? date.toString() : null;
        setDateDatePicker(date)
        setShowDatePicker(false)

        // Siempre abre el diálogo de archivo, incluso si se selecciona el mismo mes
        setTimeout(() => {
            if (RefFile.current) {
                // Reiniciamos el valor del input file antes de abrirlo para asegurar que se dispare el evento onChange
                if (RefFile.current.value) {
                    RefFile.current.value = '';
                }
                RefFile.current.click()
            }
        }, 100)

        // Actualizar la referencia del último mes seleccionado
        lastSelectedMonthRef.current = dateString;
    }

    const handleMonthSelect2 = (_, date) => {
        setDateDatePicker(date);
        // Mantener el DatePicker abierto
        setTimeout(() => {
            setShowDatePicker(true);
        }, 0);
    }

    // Función para cerrar el DatePicker cuando se hace clic fuera de él
    const handleDatePickerOpenChange = (open) => {
        if (!open) {
            setShowDatePicker(false)
        }
    }

    // Función para resetear el archivo y el DatePicker
    const handleFileRemove = () => {
        setUploadFile({ ...uploadFile, dataFile: null, nameFile: null, typeFile: null })
        setDateDatePicker(null)
        // Incrementar la key para forzar un re-render del DatePicker
        setDatePickerKey(prevKey => prevKey + 1)
    }

    const UploadFile = async () => {

        if ((!uploadFile.dataFile && !errorFile && !sendLoading)) {
            notificationGlobal('warning', 'Por favor cargue algún archivo')
            return
        }

        if (!errorFile) {
            setSendDataFile(true)
            let updateFileUpdate = { ...uploadFile, sending: false }
            setUploadFile({ ...uploadFile, sending: true, cararea: area })

            // Use the subcategory URL if available, otherwise use the default URL
            const uploadUrl = uploadFile.subcategoryUrl || uploadFile.url

            const response_upload = await dispatch(SendFileUploadFileReducer(
                { ...uploadFile, url: uploadUrl },
                area,
                dateDatePicker
            ))

            if (response_upload) {
                setLoading(true)
                setErrorFile(false)
                updateFileUpdate = { ...uploadFile, nameFile: null, typeFile: null, dataFile: null }
                // Reset del DatePicker después de una carga exitosa
                setDateDatePicker(null)
                setDatePickerKey(prevKey => prevKey + 1)
            } else {
                setLoading(true)
                setErrorFile(true)
            }
            setUploadFile({ ...updateFileUpdate, sending: false })

        } else {
            setSendDataFile(false)
            setErrorFile(false)
            setUploadFile({
                ...uploadFile,
                dataFile: null,
                typeFile: null,
                nameFile: null,
                sending: false
            })
            // Reset del DatePicker después de un error
            setDateDatePicker(null)
            setDatePickerKey(prevKey => prevKey + 1)
        }

    }
    const [showCategories, setShowCategories] = useState(true)
    const [showSubcategories, setShowSubcategories] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [activeCategory, setActiveCategory] = useState(null)
    const [selectedSubcategory, setSelectedSubcategory] = useState("Sub categoría 2")

    const handleSubcategoryClick = (subcategory) => {
        setSelectedSubcategory(subcategory.nombre)
        setSelectedCategory(activeCategory)

        // Store the subcategory URL for later use in the upload
        setUploadFile(prev => ({
            ...prev,
            subcategoryUrl: subcategory.url
        }))

        // Solo permitir abrir el diálogo de archivo si la fecha está definida
        if (dateDatePicker) {
            setShowDatePicker(false);
            setTimeout(() => {
                RefFile.current.click();
            }, 100);
        } else {
            // Mostrar notificación si la fecha no está definida
            notificationGlobal('warning', 'Por favor seleccione un mes antes de subir un archivo')
        }
    }

    // Nueva función para el modo 3: manejar clic directo en categoría
    const handleCategoryClick = (category) => {
        setSelectedCategory(category.nombre)
        
        // Store the category URL for later use in the upload
        setUploadFile(prev => ({
            ...prev,
            subcategoryUrl: category.url // Usamos la URL de la categoría directamente
        }))

        // Solo permitir abrir el diálogo de archivo si la fecha está definida
        if (dateDatePicker) {
            setShowDatePicker(false);
            setTimeout(() => {
                RefFile.current.click();
            }, 100);
        } else {
            // Mostrar notificación si la fecha no está definida
            notificationGlobal('warning', 'Por favor seleccione un mes antes de subir un archivo')
        }
    }

    const handleCategoryHover = (category) => {
        setActiveCategory(category)
        // Solo mostrar subcategorías en modo 2
        if (mode === 2) {
            setShowSubcategories(true)
        }
    }

    return (
        <>
            {
                disabled && <div className="Disabled-Card-File"></div>
            }
            <Card
                className={`Card-File ${uploadFile.sending && "Sending-File"}`}
                cover={
                    sendDataFile ?
                        uploadFile.sending
                            ? <div style={{ textAlign: 'center' }}>
                                <img src={Cargando} className="Image-Card-File" />
                            </div>
                            :
                            errorFile
                                ? <img src={Error} className="Image-Card-File" />
                                : <img src={sendLoading ? DescargaExitosa : PreCarga} className="Image-Card-File" />

                        : <img
                            className="Image-Card-File"
                            src={PreCarga}
                        />
                }
            >
                {
                    !uploadFile.sending
                        ? <>
                            {
                                errorFile
                                    ? <>
                                        <div className="Container-Message-Error">
                                            <div className="Title-Error">!Algo salió mal!</div>
                                            <div className="Text-Error">Tu archivo no se subió porque encontramos un error, por favor revisar tus notificaciones</div>
                                        </div>
                                    </>
                                    :

                                    sendLoading ?
                                        <div className={`Container-SendFile-Success`}>
                                            ¡Archivo subido con éxito!
                                        </div>
                                        : <>
                                            <Meta
                                                avatar={
                                                    mode == 1
                                                        ?
                                                        (<>
                                                            <div style={{ display: 'inline-block' }}>
                                                                <div style={{ display: 'inline-block' }}>
                                                                    <div
                                                                        onClick={() => {
                                                                            setShowDatePicker(!showDatePicker)
                                                                        }}
                                                                        className="Container-Icon-Card-File"
                                                                    >
                                                                        <PlusOutlined className="Image-Icon-Card-File" />
                                                                    </div>
                                                                </div>

                                                                <DatePicker
                                                                    key={datePickerKey} // Clave para forzar re-render
                                                                    className="Date-Card"
                                                                    onChange={(date, dateString) => {
                                                                        // Eliminamos la lógica de abrir el explorador de aquí
                                                                        // y solo manejamos el cambio de fecha
                                                                        setDateDatePicker(date);
                                                                        setShowDatePicker(false);
                                                                    }}
                                                                    onSelect={(date) => {
                                                                        // Centralizamos la lógica de abrir el explorador solo en onSelect
                                                                        // que se ejecuta tanto para nuevas selecciones como para repetidas
                                                                        setDateDatePicker(date);
                                                                        setShowDatePicker(false);

                                                                        setTimeout(() => {
                                                                            if (RefFile.current) {
                                                                                if (RefFile.current.value) {
                                                                                    RefFile.current.value = '';
                                                                                }
                                                                                RefFile.current.click();
                                                                            }
                                                                        }, 100);
                                                                    }}
                                                                    onOpenChange={handleDatePickerOpenChange}
                                                                    picker="month"
                                                                    allowClear={false}
                                                                    open={showDatePicker}
                                                                    popupClassName='DatePicker-File-Upload'
                                                                    bordered={false}
                                                                />
                                                                <input
                                                                    type="file"
                                                                    ref={RefFile}
                                                                    style={{ display: 'none' }}
                                                                    onClick={(e) => {
                                                                        // Esto permite que el evento onChange se dispare incluso si se selecciona el mismo archivo
                                                                        e.target.value = '';
                                                                    }}
                                                                    onChange={(e) => {
                                                                        if (e.target.files && e.target.files[0]) {
                                                                            setShowDatePicker(false)
                                                                            setUploadFile({
                                                                                ...uploadFile,
                                                                                dataFile: e.target.files[0],
                                                                                nameFile: e.target.files[0].name,
                                                                                typeFile: e.target.files[0].type,
                                                                                date: dateDatePicker
                                                                            })
                                                                        }
                                                                    }}
                                                                    className="Container-Icon-Card-File"
                                                                />
                                                            </div>
                                                        </>)
                                                        : ((mode == 2 || mode == 3) ? (
                                                            <>
                                                                <div style={{ display: 'inline-block' }}>
                                                                    <div style={{ display: 'inline-block' }}>
                                                                        <div
                                                                            onClick={() => {
                                                                                setShowDatePicker(!showDatePicker)
                                                                            }}
                                                                            className="Container-Icon-Card-File"
                                                                        >
                                                                            <PlusOutlined className="Image-Icon-Card-File" />
                                                                        </div>
                                                                    </div>
                                                                    <DatePicker
                                                                        key={datePickerKey} // Clave para forzar re-render
                                                                        className="Date-Card"
                                                                        onChange={handleMonthSelect2}
                                                                        picker="month"
                                                                        allowClear={false}
                                                                        open={showDatePicker}
                                                                        popupClassName='DatePicker-File-Upload'
                                                                        bordered={false}
                                                                        onOpenChange={handleDatePickerOpenChange}
                                                                        renderExtraFooter={() => (<>
                                                                            {/* Categories Dropdown */}
                                                                            {showCategories && (
                                                                                <div
                                                                                    style={{
                                                                                        position: "relative",
                                                                                        background: "white",
                                                                                        borderRadius: "8px 8px 0px 8px",
                                                                                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                                                                        width: "100%",
                                                                                        zIndex: "1",
                                                                                    }}
                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                >
                                                                                    {categoria.map((category, index) => (
                                                                                        <div
                                                                                            key={category.nombre}
                                                                                            style={{
                                                                                                padding: "0px 15px",
                                                                                                borderBottom: index < categoria.length - 1 ? "1px solid #eee" : "none",
                                                                                                display: "flex",
                                                                                                justifyContent: "space-between",
                                                                                                alignItems: "center",
                                                                                                backgroundColor: selectedCategory === category.nombre ? "#f8f9fa" : "white",
                                                                                                cursor: "pointer",
                                                                                                transition: "background-color 0.2s",
                                                                                            }}
                                                                                            onMouseEnter={(e) => {
                                                                                                e.currentTarget.style.backgroundColor = "#f0f4ff"
                                                                                                handleCategoryHover(category.nombre)
                                                                                            }}
                                                                                            onMouseLeave={(e) => {
                                                                                                if (selectedCategory !== category.nombre) {
                                                                                                    e.currentTarget.style.backgroundColor = "white"
                                                                                                } else {
                                                                                                    e.currentTarget.style.backgroundColor = "#f8f9fa"
                                                                                                }
                                                                                            }}
                                                                                            onClick={() => {
                                                                                                // En modo 3, hacemos clic directo en la categoría
                                                                                                if (mode === 3) {
                                                                                                    handleCategoryClick(category);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            <span>{category.nombre}</span>
                                                                                            {/* Solo mostrar el ícono de navegación en modo 2 */}
                                                                                            {mode === 2 && <span>›</span>}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                            {/* Subcategories Dropdown - Solo visible en modo 2 */}
                                                                            {showSubcategories && activeCategory !== null && mode === 2 && (
                                                                                <div
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        background: "white",
                                                                                        borderRadius: "8px",
                                                                                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                                                                        width: "180px",
                                                                                        zIndex: "3",
                                                                                        top: "173px",
                                                                                        left: "100%"
                                                                                    }}
                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                >
                                                                                    {categoria.find(cat => cat.nombre === activeCategory)?.subcategoria.map((subcategory, index) => {
                                                                                        // Find the active category object first
                                                                                        const activeCategoryObj = categoria.find(cat => cat.nombre === activeCategory);

                                                                                        // Only proceed if we found a valid category
                                                                                        if (!activeCategoryObj) return null;

                                                                                        return (
                                                                                            <div
                                                                                                key={subcategory.nombre}
                                                                                                style={{
                                                                                                    padding: "0px 15px",
                                                                                                    borderBottom: index < activeCategoryObj.subcategoria.length - 1 ? "1px solid #eee" : "none",
                                                                                                    display: "flex",
                                                                                                    justifyContent: "space-between",
                                                                                                    alignItems: "center",
                                                                                                    backgroundColor:
                                                                                                        selectedSubcategory === subcategory.nombre && selectedCategory === activeCategory ? "#f8f9fa" : "white",
                                                                                                    cursor: "pointer",
                                                                                                    transition: "background-color 0.2s",
                                                                                                }}
                                                                                                onMouseEnter={(e) => {
                                                                                                    e.currentTarget.style.backgroundColor = "#f0f4ff";
                                                                                                }}
                                                                                                onMouseLeave={(e) => {
                                                                                                    if (selectedSubcategory !== subcategory.nombre || selectedCategory !== activeCategory) {
                                                                                                        e.currentTarget.style.backgroundColor = "white";
                                                                                                    } else {
                                                                                                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                                                                                                    }
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    handleSubcategoryClick(subcategory);
                                                                                                }}
                                                                                            >
                                                                                                <span>{subcategory.nombre}</span>
                                                                                                {selectedSubcategory === subcategory.nombre && selectedCategory === activeCategory && (
                                                                                                    <span style={{ color: "#2ecc71" }}>✓</span>
                                                                                                )}
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                            )}
                                                                        </>)}
                                                                    />
                                                                    <input type="file" ref={RefFile} style={{ display: 'none' }}
                                                                        onChange={(e) => {
                                                                            if (e.target.files && e.target.files[0]) {
                                                                                setShowDatePicker(false)
                                                                                setUploadFile({
                                                                                    ...uploadFile,
                                                                                    dataFile: e.target.files[0],
                                                                                    nameFile: e.target.files[0].name,
                                                                                    typeFile: e.target.files[0].type,
                                                                                    date: dateDatePicker
                                                                                })
                                                                            }
                                                                        }}
                                                                        className="Container-Icon-Card-File"
                                                                    />
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <Upload maxCount={1} {...props_upload}>
                                                                <div
                                                                    className="Container-Icon-Card-File"
                                                                >
                                                                    <PlusOutlined
                                                                        className="Image-Icon-Card-File"
                                                                    />
                                                                </div>
                                                            </Upload>
                                                        ))
                                                }
                                                title={title}
                                                description={subtitle}
                                            />
                                            {
                                                template
                                                    ? <a href={template} className="Link-Template-File-Upload">Click aquí para descargar Plantilla</a>
                                                    : null
                                            }

                                            <div className={`Container-Tag-Card-File`}>
                                                {
                                                    uploadFile.nameFile && <span className="Linear-Tag-Card-File"></span>
                                                }

                                                {
                                                    uploadFile.nameFile
                                                    && <Tag
                                                        className={`Tag-Card-File`}
                                                        closable
                                                        onClose={() => {
                                                            handleFileRemove(); // Usar la nueva función para resetear archivo y DatePicker
                                                        }}
                                                    >
                                                        <Text
                                                            title={uploadFile.nameFile}
                                                            style={{ width: '100%' }}
                                                        >
                                                            {uploadFile.nameFile}
                                                        </Text>
                                                    </Tag>
                                                }
                                            </div>
                                        </>
                            }
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <button
                                    onClick={() => {
                                        setLoading(false)
                                        if (!uploadFile.dataFile && (errorFile || sendLoading)) {
                                            return
                                        }
                                        UploadFile()
                                    }} className={`Button-Card-File ${(errorFile || sendLoading) && "Button-Error"} ${(errorFile || sendLoading) && "Send-Another"}`}
                                >
                                    {
                                        errorFile || sendLoading
                                            ? <>
                                                <span className="Text-Span">Subir otro</span>
                                                <span className="Text-Span-Card-File">Subir otro</span>
                                                <div className="Circle-Button-Card-File"></div>
                                            </>
                                            : <>
                                                <span className="Text-Span">Enviar</span>
                                                <span className="Text-Span-Card-File">Enviar</span>
                                                <div className="Circle-Button-Card-File"></div>
                                            </>
                                    }
                                </button>
                            </div>
                        </>
                        : <div style={{ marginTop: '5px', marginBottom: '43px' }}>
                            <div className="Title-Loading-Card-File">Cargando...</div>
                            <div className="Text-Loading-Card-File">Cargando 1 archivo</div>
                        </div>

                }

            </Card>
        </>
    )
}

export default CardFile